module.exports = __webpack_public_path__ + "img/fuwu5.6019f573.png";